<template>
  <div>
    <img id="imageCrop" :src="src" alt="图像"/>
  </div>
</template>
<script type="text/javascript">
import Cropper from 'cropperjs'
import 'cropperjs/dist/cropper.css'
export default {
  name: 'cropper',
  props: {
    src: String
  },
  data  () {
    return {
      cropper: undefined,
      options: {
        aspectRatio: 1,
        viewMode: 1, // restrict the crop box to not exceed the size of the canvas.
        dragMode: 'move', // move the canvas
        minCropBoxWidth: 100,
        minCropBoxHeight: 100,
        restore: true
      }
    }
  },
  mounted () {
    const vm = this
    vm.cropper = new Cropper(vm.$el.querySelector('#imageCrop'), vm.options)
    vm.$emit('api', vm.cropper)
  }
}
</script>

<style type="text/css" scoped>
/* Limit image width to avoid overflow the container */
img {
  max-width: 80%; /* This rule is very important, please do not ignore this! */
  border: 1px dashed #d9d9d9;
}
</style>
